import { InventoryIssueDoc } from '@gooduncles/gu-app-schema';
import { Card, Empty } from 'antd';
import { FC } from 'react';

import useSWRUser from 'src/hooks/swr/useSWRUser';

import CardItem from 'src/atomic-components/atoms/CardItem/CardItem';
import Label from 'src/atomic-components/atoms/TextItem/Label';
import Value from 'src/atomic-components/atoms/TextItem/Value';

interface InventoryIssueViewProps {
  inventoryIssue: InventoryIssueDoc;
}

const InventoryIssueView: FC<InventoryIssueViewProps> = ({ inventoryIssue }) => {
  const { user } = useSWRUser(inventoryIssue.createdBy);
  if (!inventoryIssue) {
    return <Empty description='재고 이슈 정보가 없습니다.' />;
  }

  return (
    <Card title='재고 이슈'>
      <CardItem>
        <Label>일자</Label>
        <Value>{inventoryIssue.issueDate}</Value>
      </CardItem>
      <CardItem>
        <Label>작성자</Label>
        <Value>{user?.email}</Value>
      </CardItem>
      <CardItem>
        <Label>내용</Label>
        <Value>{inventoryIssue.reason}</Value>
      </CardItem>
    </Card>
  );
};

export default InventoryIssueView;
